import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams, ToastController, ModalController, Tabs } from 'ionic-angular';
import { ResultDetailsThumbupPage } from '../result-details-thumbup/result-details-thumbup';
import { ResultDetailsCommentPage } from '../result-details-comment/result-details-comment';

@Component({
    selector: 'page-result-details-tabs',
    templateUrl: 'result-details-tabs.html'
})
export class ResultDetailsTabsPage {

    @ViewChild('tabsId') tabs: Tabs;
    result: any;

    tab1Root = ResultDetailsThumbupPage;
    tab2Root = ResultDetailsCommentPage;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public app: App,
        public translate: TranslateService,
    ) {
        this.result = this.navParams.data.result;
        console.log(this.result);
    }

    ngAfterViewInit() {
        this.tabs.select(0);
    }
}



// WEBPACK FOOTER //
// /src/pages/results/result-details/result-details-tabs/result-details-tabs.ts